import React from 'react';

import TextInput from '../../TextInput';
import Select from '../../Select';
import Datepicker from '../../Datepicker';
import Checkbox from '../../Checkbox';
import Textarea from '../../Textarea';

function createFields(field, formik, disabled) {
  if (field.isVisible && !field.isVisible(formik.values)) {
    return null;
  }

  const type =
    typeof field.type === 'function' ? field.type(formik.values) : field.type;

  let isHidden = false;

  if (field.isHidden && typeof field.isHidden === 'function') {
    isHidden = field.isHidden(formik.values);
  }

  if (isHidden) {
    return null;
  }

  switch (type) {
    case 'text':
    case 'phone':
    case 'ssn':
    case 'ein':
    case 'number':
    case 'currency':
    case 'password':
      return (
        <div
          key={field.name}
          className={field.fullWidth ? 'sm:col-span-2' : ''}
        >
          <TextInput
            type={type}
            label={field.label}
            placeholder={field.placeholder}
            name={field.name}
            value={formik.values[field.name]}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            disabled={disabled || field.disabled}
            errors={formik.errors[field.name]}
            touched={formik.touched[field.name]}
            readOnly={field.readOnly}
          />
        </div>
      );
    case 'select':
      return (
        <div
          key={field.name}
          className={field.fullWidth ? 'sm:col-span-2' : ''}
        >
          <Select
            label={field.label}
            placeholder={field.placeholder}
            options={field.options}
            name={field.name}
            value={formik.values[field.name]}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            disabled={disabled || field.disabled}
            errors={formik.errors[field.name]}
            touched={formik.touched[field.name]}
          />
        </div>
      );
    case 'date':
      return (
        <div
          key={field.name}
          className={field.fullWidth ? 'sm:col-span-2' : ''}
        >
          <Datepicker
            label={field.label}
            placeholder={field.placeholder}
            name={field.name}
            value={formik.values[field.name]}
            onChange={formik.setFieldValue}
            onBlur={formik.handleBlur}
            disabled={disabled || field.disabled}
            errors={formik.errors[field.name]}
            touched={formik.touched[field.name]}
            setFieldValue={formik.setFieldValue}
          />
        </div>
      );
    case 'checkbox':
      return (
        <div
          key={field.name}
          className={field.fullWidth ? 'sm:col-span-2' : ''}
        >
          <Checkbox
            checkMarkAbsolute={field.checkMarkAbsolute}
            row={field.row}
            label={field.label}
            name={field.name}
            value={formik.values[field.name]}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            disabled={disabled || field.disabled}
            errors={formik.errors[field.name]}
            touched={formik.touched[field.name]}
          />
        </div>
      );
    case 'textarea':
      return (
        <div key={field.name} className="sm:col-span-2">
          <Textarea
            label={field.label}
            placeholder={field.placeholder}
            name={field.name}
            value={formik.values[field.name]}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            disabled={disabled || field.disabled}
            errors={formik.errors[field.name]}
            touched={formik.touched[field.name]}
          />
        </div>
      );
    default:
      return null;
  }
}

export default function useFormFields(fields, formik, disabled) {
  return fields.map((field) => createFields(field, formik, disabled));
}
